import { useDispatch } from "react-redux"

import { Button } from "@mui/material"
import { ContentContainer, MessageContainer, Title, Subtitle, IconContainer } from "./styled"
import IconBox from "../../components/IconBox"
import UIIcon from "../../components/UIIcon"
import { setNextStep } from "../../store/slices/routingSlice/routingSlice"
import SBPIconNoExt from "../../components/SBPIconNoExt"

const UpdateDefaultBankFail = () => {
  const dispatch = useDispatch()

  const handleClickDone = () => {
    dispatch(setNextStep())
  }

  return (
    <ContentContainer>
      <MessageContainer>
        <IconBox size="lg" color="yellow">
          <UIIcon iconName="errorTransfer" size={80} />
        </IconBox>
        <Title variant="h3">Код введен неверно</Title>
        <Subtitle variant="h5">Операция неуспешна</Subtitle>
      </MessageContainer>
      <IconContainer>
        <SBPIconNoExt size={60} />
      </IconContainer>
      <Button variant="contained" fullWidth onClick={handleClickDone}>
        Закрыть
      </Button>
    </ContentContainer>
  )
}

export default UpdateDefaultBankFail
